import { render, staticRenderFns } from "./FooterAcademy.vue?vue&type=template&id=ba5fc9c6&"
import script from "./FooterAcademy.vue?vue&type=script&lang=js&"
export * from "./FooterAcademy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports